"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddDriverPolarAnswerWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_model_1 = require("@athena-portal/journey-model");
var services_1 = require("@falcon/services");
var AddDriverPolarAnswerWidget = /** @class */ (function (_super) {
    __extends(AddDriverPolarAnswerWidget, _super);
    function AddDriverPolarAnswerWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnChangeEvent = function (event) {
            var _a;
            _this.setState({ nextButtonDisabled: false });
            var maxAdditionalDriversCount = ((_a = _this.props.interaction) === null || _a === void 0 ? void 0 : _a.product) === services_1.ProductsEnum.WOLF_MOTOR ? 5 : 7;
            var additionalDriverIndex = _this.getSetting("additionalDriverIndex") !== undefined ? _this.getSetting("additionalDriverIndex") : 0;
            if (event.target.value === "true" && (additionalDriverIndex < maxAdditionalDriversCount)) {
                if ([services_1.INTERACTION_PROCESS_MTA_ADD_PERMANENT_DRIVER, services_1.INTERACTION_PROCESS_SUPPORT_PORTAL_ADD_ADDITIONAL_DRIVER, services_1.INTERACTION_PROCESS_RENEWAL_PROPOSAL].includes(_this.props.interaction.process)) {
                    additionalDriverIndex++;
                    _this.setState({
                        nextPageId: "additionalDriver".concat(additionalDriverIndex, "DrivingLicenceScanPage"),
                        validationMessage: ""
                    });
                }
                else {
                    _this.setState({
                        nextPageId: "anyVehicleAddDriverPage",
                        validationMessage: ""
                    });
                }
            }
            else if ([services_1.INTERACTION_PROCESS_MTA_ADD_PERMANENT_DRIVER, services_1.INTERACTION_PROCESS_RENEWAL_PROPOSAL, services_1.INTERACTION_PROCESS_SUPPORT_PORTAL_ADD_ADDITIONAL_DRIVER].includes(_this.props.interaction.process)) {
                _this.setState({
                    nextPageId: "additionalDriver".concat(additionalDriverIndex, "MainDriver"),
                    validationMessage: ""
                });
            }
            else {
                _this.setState({ nextPageId: "additionalCarDetails", validationMessage: "" });
            }
        };
        _this.navigateNext = function () {
            if (_this.state.nextPageId) {
                _this.props.engine.navigate(_this.state.nextPageId);
            }
            else {
                _this.setState({ validationMessage: "Please answer this to carry on" });
            }
        };
        _this.navigateBack = function () {
            if (_this.isMtaJourney()) {
                window.location.assign("/dashboard/annualMotor/yourCars/".concat(_this.props.interaction.agreementNumber));
            }
            else if (_this.getSetting("previousPageId")) {
                _this.props.engine.navigate(_this.getSetting("previousPageId"));
            }
        };
        props.engine.setJourneyState({
            pageIdForNavigation: "addDriver"
        });
        _this.state = {
            nextPageId: undefined,
            validationMessage: "",
            nextButtonDisabled: true,
        };
        return _this;
    }
    AddDriverPolarAnswerWidget.prototype.render = function () {
        var _a;
        var allAdditionalDrivers = this.props.interaction.additionalDrivers || [];
        var additionalDriversCount = allAdditionalDrivers.length;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "w-auto polaris-answer-wdg", children: [(0, jsx_runtime_1.jsxs)("div", { className: "panel form-group p-4", children: [(0, jsx_runtime_1.jsx)("label", { className: "no-outline", children: "Do you want to add another driver to the policy?" }), !this.getSetting("hideMaxNumberOfDriversInfo") && (0, jsx_runtime_1.jsxs)("p", { children: ["You can add up to ", (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: ((_a = this.props.interaction) === null || _a === void 0 ? void 0 : _a.product) === services_1.ProductsEnum.WOLF_MOTOR ? 5 : 7 }), " additional drivers."] }), (0, jsx_runtime_1.jsxs)("p", { children: ["You have ", (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: additionalDriversCount > 0 ? additionalDriversCount : "no" }), " additional driver(s) added."] }), additionalDriversCount > 0 &&
                            (0, jsx_runtime_1.jsx)("ul", { className: "multiple-drivers-ul", children: allAdditionalDrivers.map(function (driver, index) { return ((0, jsx_runtime_1.jsx)("li", { className: "multiple-drivers-li", children: "".concat(driver.firstName, " ").concat(driver.lastName) }, index)); }) }), (0, jsx_runtime_1.jsxs)("div", { className: "input-group", role: "group", "aria-label": "Do you want to add another driver to the policy?", children: [(0, jsx_runtime_1.jsxs)("div", { className: "custom-control custom-radio", children: [(0, jsx_runtime_1.jsx)("input", { id: "".concat(this.props.question.name, "-true"), className: "custom-control-input", type: "radio", name: this.props.question.name, value: "true", onChange: this.handleOnChangeEvent }), (0, jsx_runtime_1.jsx)("label", { className: "custom-control-label", htmlFor: "".concat(this.props.question.name, "-true"), children: "Yes" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "custom-control custom-radio", children: [(0, jsx_runtime_1.jsx)("input", { id: "".concat(this.props.question.name, "-false"), className: "custom-control-input", type: "radio", name: this.props.question.name, value: "false", onChange: this.handleOnChangeEvent }), (0, jsx_runtime_1.jsx)("label", { className: "custom-control-label", htmlFor: "".concat(this.props.question.name, "-false"), children: "No" })] })] }), (0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block", role: "alert", children: this.state.validationMessage })] }), (0, jsx_runtime_1.jsxs)("button", { className: "btn btn-primary btn-next-arrow-separate", id: "".concat(this.props.question.name), disabled: this.state.nextButtonDisabled, onClick: this.navigateNext, children: ["Next", (0, jsx_runtime_1.jsx)("img", { className: "arrow-next", alt: "Arrow icon", src: "/img/arrow-next.png" })] }), this.getSetting("previousPageId") &&
                    (0, jsx_runtime_1.jsx)("button", { className: "btn btn-back", onClick: this.navigateBack, children: this.isMtaJourney() ? 'Cancel changes' : 'Back' })] }));
    };
    AddDriverPolarAnswerWidget.prototype.isMtaJourney = function () {
        return this.props.process === services_1.INTERACTION_PROCESS_RENEWAL_PROPOSAL
            || this.props.process === services_1.INTERACTION_PROCESS_MTA_ADD_PERMANENT_DRIVER
            || this.props.process === services_1.INTERACTION_PROCESS_MTA_ADD_TEMPORARY_DRIVER;
    };
    AddDriverPolarAnswerWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "previousPageId", type: journey_model_1.TypeDescriptions.String },
            { name: "hideMaxNumberOfDriversInfo", type: journey_model_1.TypeDescriptions.Boolean },
            { name: "additionalDriverIndex", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], AddDriverPolarAnswerWidget);
    return AddDriverPolarAnswerWidget;
}(plugin_journey_1.WidgetBase));
exports.AddDriverPolarAnswerWidget = AddDriverPolarAnswerWidget;
//# sourceMappingURL=AddDriverPolarAnswerWidget.js.map